
const generateRandomUUID = () => {
    const randomId = Math.floor(Math.random() * 1000000000);
    return randomId;
}

export default generateRandomUUID